export const AGGREGATION_INTERVAL_15S = '15s';
export const AGGREGATION_INTERVAL_30S = '30s';
export const AGGREGATION_INTERVAL_1MIN = '1min';
export const AGGREGATION_INTERVAL_10MIN = '10min';
export const AGGREGATION_INTERVAL_1H = '1hour';
export const AGGREGATION_INTERVAL_1D = '1day';
export const AGGREGATION_INTERVAL_1W = '1week';

export const AGGREGATION_INTERVALS = {
  [AGGREGATION_INTERVAL_15S]: {
    label: '15 seconds',
    seconds: 15,
    milliseconds: 15 * 1000,
  },
  [AGGREGATION_INTERVAL_30S]: {
    label: '30 seconds',
    seconds: 30,
    milliseconds: 30 * 1000,
  },
  [AGGREGATION_INTERVAL_1MIN]: {
    label: '1 minute',
    seconds: 60,
    milliseconds: 60 * 1000,
  },
  [AGGREGATION_INTERVAL_10MIN]: {
    label: '10 minutes',
    seconds: 600,
    milliseconds: 600 * 1000,
  },
  [AGGREGATION_INTERVAL_1H]: {
    label: '1 hour',
    seconds: 3600,
    milliseconds: 3600 * 1000,
  },
  [AGGREGATION_INTERVAL_1D]: {
    label: '1 day',
    seconds: 3600 * 24,
    milliseconds: 3600 * 24 * 1000,
  },
  [AGGREGATION_INTERVAL_1W]: {
    label: '1 week',
    seconds: 3600 * 24 * 7,
    milliseconds: 3600 * 24 * 7 * 1000,
  },
};
